/* eslint-disable jsx-a11y/alt-text */
import React from 'react'

import { cloudinary } from './cloudinary'

export type CloudinarySvgImageProps =
  React.ImgHTMLAttributes<HTMLImageElement> & {
    publicId: string | undefined
  }

/**
 * @deprecated Use cloud-image instead.
 *
 * Use svg file from cloudinary as image
 *
 * @see {@link https://cloudinary.com/documentation/javascript_integration|Cloudinary JavaScript SDK}
 * @see {@link https://cloudinary.com/documentation/javascript_image_transformations|JavaScript SDK image transformations}
 *
 *
 * @example
 * import { CloudinarySvgImage } from '@/cloudinary/CloudinaryImage'
 *
 * <CloudinarySvgImage
 *   publicId="system/group-icon.svg"
 *   width="76px"
 *   height="52px"
 * />
 *
 *
 */
export function CloudinarySvgImage({
  publicId,
  ...imgAttributes
}: CloudinarySvgImageProps) {
  if (!publicId) {
    return null
  }

  const image = cloudinary.image(publicId)

  return <img {...imgAttributes} src={image.toURL()} />
}
